import router from './router'
import useAuthStore from './store'

export default {
  router,
  useAuthStore,
}
